import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=0ee9a2bc&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports